import { createRouter, createWebHistory } from "vue-router/dist/vue-router.esm-bundler";
import { isAuthenticated } from "@/services/auth";

import Vikings from "@/view/vikings/Vikings.vue";
import VikingsOverview from "@/view/vikings/Overview.vue";
import VikingsResults from "@/view/vikings/VikingsResults.vue";
import VikingsMaps from "@/view/vikings/VikingsMaps.vue";
import VikingsReferences from "@/view/vikings/VikingsReferences.vue";

import Bakers from "@/view/bakers/Bakers.vue";
import RecentAncestry from "@/view/ancestry/recent/RecentAncestry.vue";
import RecentOverview from "@/view/ancestry/recent/RecentOverview.vue";
import RecentMap from "@/view/ancestry/recent/RecentMap.vue";
import RecentBook from "@/view/ancestry/recent/RecentBook.vue";
import RecentVersion from "@/view/ancestry/recent/RecentVersion.vue";

import MotherLine from "@/view/ancestry/motherline/MotherLine.vue";
import MotherLineOverview from "@/view/ancestry/motherline/MotherLineOverview.vue";
import MotherLineHistory from "@/view/ancestry/motherline/MotherLineHistory.vue";
import MotherLineMap from "@/view/ancestry/motherline/MotherLineMap.vue";
import MotherLineMigrationMap from "@/view/ancestry/motherline/MotherLineMigrationMap.vue";

import FatherLine from "@/view/ancestry/fatherline/FatherLine.vue";
import FatherLineOverview from "@/view/ancestry/fatherline/FatherLineOverview.vue";
import FatherLineHistory from "@/view/ancestry/fatherline/FatherLineHistory.vue";
import FatherLineMap from "@/view/ancestry/fatherline/FatherLineMap.vue";
import FatherLineMigrationMap from "@/view/ancestry/fatherline/FatherLineMigrationMap.vue";

import Archaic from "@/view/archaic/Archaic.vue";
import ArchaicOverview from "@/view/archaic/ArchaicOverview.vue";
import ArchaicMap from "@/view/archaic/ArchaicMap.vue";
import ArchaicResults from "@/view/archaic/ArchaicResults.vue";
import ArchaicTraits from "@/view/archaic/ArchaicTraits.vue";
import ArchaicReferences from "@/view/archaic/ArchaicReferences.vue";

import Classical from "@/view/ancestry/classical/Classical.vue";
import ClassicalOverview from "@/view/ancestry/classical/ClassicalOverview.vue";
import RomanOverview from "@/view/ancestry/classical/roman/RomanOverview.vue";
import GreekOverview from "@/view/ancestry/classical/greek/GreekOverview.vue";
import EgyptianOverview from "@/view/ancestry/classical/egyptian/EgyptianOverview.vue";

import HealthStore from "@/view/store/HealthStore.vue";
import CategoryStore from "@/view/store/CategoryStore.vue";
import StoreSuccessview from "@/view/store/StoreSuccessview.vue";

import BloodTest from "@/view/health/Blood/BloodTest.vue";
import FunctionEfficiency from "@/view/health/Blood/FunctionEfficiency.vue";
import BloodTestResult from "@/view/health/Blood/BloodTestResult.vue";
import BookConsultation from "@/view/health/Blood/BookConsultation.vue";
import LiverFunction from "@/view/health/Blood/LiverFunctionBkp.vue";
import KidneyElectrolytes from "@/view/health/Blood/KidneyElectrolytes.vue";
import BloodDetails from "@/view/health/Blood/BloodDetails.vue";
import AncestryDetails from "@/view/health/Blood/AncestryDetails.vue";

import ArchaicUpgrade from "@/view/archaic/ArchaicUpgrade.vue";
import ArchaicNeatherland from "@/view/archaic/AncestryNeatherLand.vue";

import AddProfilePicture from "@/view/signup/AddProfilePicture.vue";
import PersonalInfoActivation from "@/view/signup/PersonalInfoActivation.vue";
import AddUsername from "@/view/signup/AddUsername.vue";
import KitActivatedStatus from "@/view/signup/KitActivatedStatus.vue";

import KitActivationRoutes from "./activation";
import ProfileRoutes from "./profile";
import EpigeneticsRoutes from "./epigenetics";

import Sharing from "@/view/sharing/Sharing.vue";
import Bakersharing from "@/view/sharing/Bakersharing.vue";
//import { hasHealthAccess } from "@/services/health/health";
import store from "@/store";
import { hasProfile, loadPortal } from "@/services/portalEntry";
import { setPartnerReferral, hasPartnerReferral, sendUploadReferralToServer, getPartnerReferral } from "@/services/uploadReferral";
import { menuClickCount } from '@/store/menuStore.js';

const router = createRouter({
    history: createWebHistory(),
    routes: [
          {
            path: "/bakershare/:uuid",
            component: Bakersharing,
            meta: {
                public: true,
            },
            children: []
        },
        {
            path: "/share/:uuid",
            component: Sharing,
            meta: {
                public: true,
            },
            children: []
        },
        {
            path: "",
            name: "dashboard",
            component: () => import("@/view/dashboard/UserDashboard.vue"),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/kit/:barcode/new-sample-kit",
            name: "new-sample-kit",
            component: () => import("@/view/recollection/NewSampleKit.vue"),
            meta: {
                requiresAuth: true,
            },
        },
        ...ProfileRoutes,
        {
            path: "/signin",
            name: "signin",
            component: () => import("@/view/signin/SignIn.vue"),
            meta: {
                requiresAuth: false,
                public: true,
            },
            children: [
                {
                    path: "",
                    name: "login",
                    component: () => import("@/view/signin/LoginForm.vue"),
                },
                {
                    path: "reset-password",
                    name: "reset-password",
                    component: () => import("@/view/signin/reset-password/ResetPassword.vue"),
                },
                {
                    path: "reset-email-sent",
                    name: "reset-password-email-sent",
                    component: () =>
                        import("@/view/signin/reset-password/ResetEmailSentSuccessfully.vue"),
                },
                {
                    path: "create-password/:token",
                    name: "create-new-password",
                    component: () => import("@/view/signin/reset-password/CreateNewPassword.vue"),
                },
                {
                    path: "validate-email/:token",
                    name: "validate-email",
                    component: () => import("@/view/signin/VerifyEmail.vue"),
                },
                {
                    // The link emailed to a new address; see the API's frontend_email_change_confirm.
                    path: "confirm-email/:token",
                    name: "confirm-email-change",
                    component: () => import("@/view/signin/ConfirmEmailChange.vue"),
                }
            ],
        },
        {
            path: "/restore-account",
            name: "restore-account",
            component: () => import("@/view/profile/DeleteAccount/RestoreAccount.vue"),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/signup",
            name: "signup",
            component: () => import("@/view/signup/SignUp.vue"),
            meta: {
                requiresAuth: false,
                public: true,
            },
            children: [
                {
                    path: "",
                    name: "register",
                    component: () => import("@/view/signup/RegistrationForm.vue"),
                },
            ],
        },
        {
            path: "/add/profile/picture",
            component: AddProfilePicture,
        },
        // New Added 3 screens
        {
            path: "/activation/personal/info",
            component: PersonalInfoActivation
        },
        {
            path: "/activation/add/username",
            component: AddUsername
        },
        {
            path: "/activation/kit/status",
            component: KitActivatedStatus
        },
         {
            path: "/bakers",
            component: Bakers,
            redirect: "/bakers/overview",
            meta: {
                requiresAuth: false,
            },
            children: [
                {
                    path: "overview",
                    name: "bakers-overview",
                    component: () => import("@/view/bakers/Overview.vue"),
                },
                {
                    path: "detail",
                    name: "bakers-detail",
                    component: () => import("@/view/bakers/Detail.vue"),
                },
                {
                path: "detail/:trait?",
                name: "bakers-detail",
                component: () => import("@/view/bakers/Detail.vue")
                },
                {
                path: "/detail/:category?/:subcat?",
                name: "bakers-detail",
                component: () => import("@/view/bakers/Detail.vue"),
                props: true
                }
                
            ],
        },
        // New Added 3 screens
        {
            path: "/vikings",
            component: Vikings,
            redirect: "/vikings/overview",
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: "overview",
                    name: "viking-overview",
                    component: VikingsOverview,
                },
                {
                    path: "results",
                    name: "viking-results",
                    component: VikingsResults,
                },
                {
                    path: "maps",
                    name: "viking-map",
                    component: VikingsMaps,
                },
                {
                    path: "references",
                    name: "viking-references",
                    component: VikingsReferences,
                },
            ],
        },
        {
            path: "/store/:tab?",
            name: "HealthStore",
            component: HealthStore,
            meta: {
                requiresAuth: true,
            },
        },

        {
            path: "/categories/store/:tab?",
            name: "CategoryStore",
            component: CategoryStore,
            meta: {
                requiresAuth: true,
            },
        },

        {
            path: "/health/store/success",
            name: "store-success",
            component: StoreSuccessview,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: "/ancestry",
            redirect: "/ancestry/overview",
            component: RecentAncestry,
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: "overview",
                    name: "recent-overview",
                    component: RecentOverview,
                },
                {
                    path: "recent/:groupId?",
                    component: RecentMap,
                    name: "recent-map",
                },
                {
                    path: "versions",
                    name: "recent-versions",
                    component: RecentVersion,
                },
                {
                    path: "book-pdf",
                    name: "book-pdf",
                    component: RecentBook,
                },
            ],
        },
        {
            path: "/motherline",
            component: MotherLine,
            redirect: "/motherline/overview",
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: "overview",
                    name: "motherline-ancestry",
                    component: MotherLineOverview,
                },
                {
                    path: "history",
                    name: "motherline-history",
                    component: MotherLineHistory,
                },
                {
                    path: "distribution-map",
                    name: "motherline-map",
                    component: MotherLineMap,
                },
                {
                    path: "migration-map",
                    name: "motherline-migration",
                    component: MotherLineMigrationMap,
                },
                {
                    path: "distribution-map/:region?",
                    name: "motherline-distribution-map",
                    component: MotherLineMap,
                },
            ],
        },

        {
            path: "/fatherline",
            component: FatherLine,
            redirect: "/fatherline/overview",
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: "overview",
                    name: "Fatherline-ancestry",
                    component: FatherLineOverview,
                },
                {
                    path: "history",
                    name: "Fatherline-history",
                    component: FatherLineHistory,
                },
                {
                    path: "distribution-map",
                    name: "fatherline-map",
                    component: FatherLineMap,
                },
                {
                    path: "/distribution-map/:region?",
                    name: "fatherline-distribution-map",
                    component: FatherLineMap,
                },
                {
                    path: "migration-map",
                    name: "fatherline-migration",
                    component: FatherLineMigrationMap,
                },
            ],
        },

        {
            path: "/archaic/upgrade",
            name: "archaic-upgrade",
            component: ArchaicUpgrade,
        },
        {
            path: "/archaic/neatherlands",
            name: "archaic-neatherlands",
            component: ArchaicNeatherland,
        },
        {
            path: "/archaic",
            component: Archaic,
            redirect: "/archaic/overview",
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: "overview",
                    name: "archaic-overview",
                    component: ArchaicOverview,
                },
                {
                    path: "maps",
                    name: "archaic-maps",
                    component: ArchaicMap,
                },
                {
                    path: "results",
                    name: "archaic-results",
                    component: ArchaicResults,
                },
                {
                    path: "traits",
                    name: "archaic-traits",
                    component: ArchaicTraits,
                },

                {
                    path: "references",
                    name: "references",
                    component: ArchaicReferences,
                },
            ],
        },

        {
            path: "/family-matching",
            component: () => import("@/view/familymatching/FamilyMatching.vue"),
            redirect: "/family-matching/list",
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: "list",
                    name: "relative-list",
                    component: () => import("@/view/familymatching/RelativeList.vue"),
                },
                {
                    path: "matchbox",
                    name: "matchbox",
                    component: () => import("@/view/familymatching/MatchBox.vue"),
                },
                {
                    path: "messaging-center",
                    name: "messaging-center",
                    component: () => import("@/view/familymatching/MessagingCenter.vue"),
                },
                {
                    path: "multiview-browser",
                    name: "multiview-browser",
                    component: () => import("@/view/familymatching/MultiView.vue"),
                },
                {
                    path: "profile/:barcode",
                    name: "profile-details",
                    redirect: (to) => {
                        return `/family-matching/profile/${to.params.barcode}/conversation`;
                    },
                    component: () => import("@/view/familymatching/FamilyMatchingProfile.vue"),
                    children: [
                        {
                            path: "conversation",
                            name: "profile-conversation",
                            component: () => import("@/components/TabModule/TabConversation.vue"),
                        },
                        {
                            path: "relationship",
                            name: "profile-relationship",
                            component: () => import("@/components/TabModule/RelationshipTree.vue"),
                        },
                        {
                            path: "notes",
                            name: "profile-notes",
                            component: () => import("@/components/TabModule/ProfileNotes.vue"),
                        },
                        {
                            path: "map",
                            name: "profile-map",
                            component: () => import("@/components/TabModule/SharedMap.vue"),
                        },
                        {
                            path: "chromosome-browser",
                            name: "profile-chromosome-browser",
                            component: () => import("@/components/TabModule/SharedDna.vue"),
                        },
                    ],
                },
            ],
        },

        {
            path: "/classical",
            component: Classical,
            redirect: "/classical/overview",
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: "overview",
                    name: "Classical-overview",
                    component: ClassicalOverview,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "roman",
                    name: "Roman-overview",
                    component: RomanOverview,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "greek",
                    name: "Greek-overview",
                    component: GreekOverview,
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "egyptian",
                    name: "Egyptian-overview",
                    component: EgyptianOverview,
                    meta: {
                        requiresAuth: true,
                    },
                },
            ],
        },

        {
            path: "/health/supplements",
            name: "supplements",
            component: () => import("@/view/health/supplements/HealthSupplements.vue"),
            meta: {
                requiresHealthAccess: false
            }
        },

        {
            path: "/health",
            name: "health",
            redirect: "/health/wellbeing",
            component: () => import("@/view/health/wellbeing/HealthWellbeing.vue"),
            meta: {
                requiresAuth: false,
                requiresHealthAccess: false
            },
            children: [
                {
                    path: "wellbeing",
                    name: "wellbeing",
                    component: () => import("@/view/health/wellbeing/WellbeingTraits.vue"),
                },
                {
                    path: "wellbeing/:detail",
                    name: "wellbeing-detail",
                    component: () => import("@/view/health/wellbeing/WellbeingDetail.vue"),
                },
                {
                    path: "wellbeing/:detail/science",
                    name: "wellbeing-detail-science",
                    component: () => import("@/view/health/wellbeing/ExploreScience.vue"),
                },
            ],
        },

        // Blood Test Routes
        {
            path: "/blood/test",
            name: "bloodTest",
            component: BloodTest,
            meta: {
                requiresHealthAccess: true
            }
        },

        {
            path: "/blood/test/details/:product",
            name: "bloodTestDetails",
            component: BloodDetails,
            meta: {
                requiresHealthAccess: true
            }
        },
        {
            path: "/ancestry/details/:slug",
            name: "AncestryDetails",
            component: AncestryDetails,
        },
        {
            path: "/function/efficiency/:barcode",
            name: "functionEfficiency",
            component: FunctionEfficiency,
        },
        {
            path: "/liver/funtion",
            name: "LiverFunction",
            component: LiverFunction,
        },
        {
            path: "/kidney/electrolytes/:barcode/:panel",
            name: "KidneyElectrolytes",
            component: KidneyElectrolytes,
        },
        {
            path: "/blood/test/result/:marker/:panel",
            name: "bloodTestTest",
            component: BloodTestResult,
            meta: {
                requiresHealthAccess: true
            }
        },
        {
            path: "/book/consultation",
            name: "bookConsultation",
            component: BookConsultation,
            meta: {
                requiresHealthAccess: true
            }
        },
        {
            path: "/blood/test/report/:barcode",
            name: "bloodTestReport",
            component: FunctionEfficiency,
            meta: {
                requiresHealthAccess: true
            }
        },

        {
            path: "/health/genetics",
            redirect: { name: "genetics-reports" },
            component: () => import("@/view/health/Genetics/GeneticsHome.vue"),
            meta: {
                requiresAuth: true,
                requiresHealthAccess: true
            },
            children: [
                {
                    path: "reports",
                    name: "genetics-reports",
                    component: () => import("@/view/health/Genetics/AllReports.vue"),
                },
                {
                    path: "category/:category",
                    name: "genetics-category",
                    component: () => import("@/view/health/Genetics/GeneticsCategory.vue"),
                },
                {
                    path: "category/:category/science/:trait",
                    name: "genetics-science",
                    component: () => import("@/view/health/Genetics/GeneticsScienceDetails.vue"),
                },
            ],
        },
          {
            path: "/health/epigenetics",
            redirect: "/health/epigenetics/reports",
            component: () => import("@/view/health/Epigenetics/EpigeneticsHome.vue"),
            meta: {
                requiresAuth: true,
                requiresHealthAccess: true
            },
            children: [
                {
                    path: "reports",
                    name: "epigenetics-reports",
                    component: () => import("@/view/health/Epigenetics/EpigeneticsAllReports.vue"),
                },
                {
                    path: "overview",
                    name: "epigenetics-overview",
                    component: () => import("@/view/health/Epigenetics/Overview.vue"),
                },
                {
                    path: "epigeneticdata",
                    name: "epigenetics-data",
                    component: () => import("@/view/health/Epigenetics/EpigeneticsData.vue"),
                },
                {
                 path: "epigeneticreports/:barcode?",
                 name: "epigenetics-category-reports",
                    component: () => import("@/view/health/Epigenetics/EpigeneticsReport.vue"),
                    
                },
          
                 {
                    path: "epigeneticmultiplereports",
                    name: "epigenetics-categorymultiple-reports",
                    component: () => import("@/view/health/Epigenetics/EpigeneticsMultiReport.vue"),
                },
                {
                    path: "epigeneticriskfactor",
                    name: "epigenetics-riskfactor",
                    component: () => import("@/view/health/Epigenetics/EpigeneticsRiskFactor.vue"),
                },
                // ✅ NEW: Added the backend data dashboard route
                {
                    path: "backend-dashboard",
                    name: "epigenetics-backend-dashboard",
                    component: () => import("@/view/health/Epigenetics/EpigeneticsDataDashboard.vue"),
                },
                {
                    path: "category/:category",
                    name: "epigenetics-category",
                    component: () => import("@/view/health/Epigenetics/EpigeneticsCategory.vue"),
                },
                {
                    path: "category/:category/science/:trait",
                    name: "epigenetics-science",
                    component: () => import("@/view/health/Epigenetics/EpigeneticsScienceDetails.vue"),
                },
            ],
        },
        ...KitActivationRoutes,
        ...EpigeneticsRoutes,
        {
            path: "/:pathMatch(.*)*",
            component: () => import("@/components/PageNotFound.vue"),
        },
    ],
});

// Add a global navigation guard to check for authentication
router.beforeEach(async (to, from, next) => {
    if (to.meta.public && !isAuthenticated()) {
        next();
        return;
    }
    
    if (to.meta.public && isAuthenticated()) {
        next();
        return;
    }

    if (to.meta.requiresAuth && !isAuthenticated()) {
        next("/signin");
        return;
    }

    // While the account is scheduled for deletion, the only page is the one to restore it.
    if (isAuthenticated() && store.getters.account?.pendingDeletion && to.name !== "restore-account") {
        next({ name: "restore-account" });
        return;
    }

    // The dashboard assumes a profile is loaded. A session can be without one (signed in while
    // the account was pending deletion, then restored), and reloading keeps the store as it
    // was, so load the portal the way signing in does instead of showing a broken page.
    if (to.name === "dashboard" && isAuthenticated() && !hasProfile()) {
        try {
            if (!(await loadPortal())) {
                next({ name: "activation" });
                return;
            }
        } catch (err) {
            console.error("Could not load the portal", err);
        }
    }

    if (to.query.upload_referral) {
        setPartnerReferral(to.query.upload_referral, to.query.type);
    }

    if (hasPartnerReferral()) {
        try {
            if (localStorage.getItem("token")) {
                // You might need to adjust this based on your new store structure
                await store.dispatch("fetchProfile")
                sendUploadReferralToServer(store.getters.profile.profile.barcode, getPartnerReferral());
            }
        } catch (e) {
            // Error handling
        }
    }

    if (to.meta.referrer) {
        if (to.query.referrer || store.getters.referrer) {
            if (to.query.referrer) {
                store.dispatch("setReferrer", to.query.referrer);
            }
        }
    }
    //for get the count of menu you visit
    menuClickCount.value++; // ✅ Increase the count
    if (to.meta.requiresHealthAccess) {
        try {
            const hasAccess = true; //await hasHealthAccess();
            if (hasAccess) {
                next();
            } else if (from.fullPath === '/') {
                next('/');
            }
        } catch (error) {
            console.error('Error checking health access:', error);
            next('/');
        }
        return;
    }
    next()
});

// A tab opened before a deploy still runs the previous build, which asks for chunks the new
// build doesn't have (ChunkLoadError). Reload once onto the page it was opening to pick up the
// new build; remembering that page stops a reload loop when the chunk is missing for another reason.
const CHUNK_RELOAD_KEY = "chunkReloadFor";

router.onError((error, to) => {
    const chunkFailed = error?.name === "ChunkLoadError" || /Loading (CSS )?chunk .+ failed/.test(error?.message ?? "");
    if (!chunkFailed) return;
    try {
        if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === to.fullPath) return;
        sessionStorage.setItem(CHUNK_RELOAD_KEY, to.fullPath);
    } catch {
        return; // without storage a first failure can't be told from a loop
    }
    window.location.assign(to.fullPath);
});

router.afterEach((to, from, failure) => {
    if (failure) return;
    try {
        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    } catch {
        // storage unavailable: nothing was remembered
    }
});

export default router;
